<template>
  <v-card
    v-if="hasKeyActive"
    ref="searchModelDialog"
    class="searchModelDialog"
    color="bannerBackground"
    :loading="loadingSearch"
    :flat="!isListMode"
  >
    <v-text-field
      ref="searchInputTextModel"
      v-model="searchText"
      class="searchInputModel"
      :class="{ listActive: listActive, animated: !modelPrice && !searchText }"
      :label="$t('general.Selecciona un modelo')"
      prepend-inner-icon="$fi-search"
      solo
      hide-details
      rounded
      :color="color"
      @input="searchDebounce"
      @blur="hideList"
      @focus="showList"
    ></v-text-field>
    <v-list v-if="listActive && isListMode && searchResult?.length" class="listSerachModel" subheader @mousedown="itemMouseDown">
      <v-list-item v-for="modelo in searchResult" :key="modelo.code" class="item-list">
        <v-list-item-avatar>
          <v-img :src="modelo.imagemodelurl"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <div class="d-flex align-center">
            <v-list-item-title>
              <div v-if="modelo" class="text-wrap" v-html="getSearchItemText(modelo)"></div>
            </v-list-item-title>
            <cotizador-btn
              :on="{
                click: () => {
                  loadModel(modelo.code);
                }
              }"
            >
              {{ $t("general.Seleccionar") }} 
            </cotizador-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div v-else-if="searchResult && !isListMode" class="grid-list bannerBackground"  @wheel.prevent="handleWheel">

      <div v-for="modelo in searchResult" :key="modelo.code" class="model-card" outlined @click="loadModel(modelo.code)">
            <v-img
              v-if="modelo"
              :src="getBestProductImage(modelo)"
              class="model-image"
              aspect-ratio="1.5"
            ></v-img>
          <v-img :src="getBestProductImage(modelo)" />
            <div v-if="modelo" class="title-model"><span v-html="getSearchItemText(modelo)" /></div>
        </div>
      

    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

import CotizadorBtn from "@/components/basic/CotizadorBtn.vue";
export default {
  components: {
    CotizadorBtn
  },
  props: {
    color: {
      type: String,
      default: "bannerBackground"
    },
    isOnModal: {
      type: Boolean,
      default: false
    },
    focusInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchText: "",
      searchResult: [],
      loadingSearch: false,
      cancelationToken: null,
      showListActive: false,
      clickedInside: false,
    
      mode: 'grid'
    };
  },
  computed: {
    ...mapGetters("modelo", ["codigosModelos", "modelPrice", "catalogInfo", "modelCode"]),
    ...mapGetters("config", [
      "actualLanguageRegion",
      "key",
      "youReprocesosSession"
    ]),
    // Indica si tenemos resultados o no
    listActive() {
      return this.isListMode && this.searchResult && this.searchResult.length > 0 && this.showListActive;
    },
    hasKeyActive() {
      return this.key || this.youReprocesosSession;
    },
    isListMode() {
      return this.mode === 'list'
    }
  },
  watch: {
    hasKeyActive() {
      this.searchText = "";
      let modeloId = this.$route.query.modelo;
      if (modeloId) this.loadModel(modeloId);
    },
    loadingSearch(newVal, oldVal)
    {
      if(newVal != oldVal)
      {
        this.$emit('loading-modal')
      }
    },
    focusInput(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$nextTick(() => {
          this.$refs.searchInputTextModel && this.$refs.searchInputTextModel.focus();
        });
      }
    }
  },
  async mounted() {
    this.searchText = "";
    let modeloId = this.$route.query.modelo;
    if (modeloId) await this.loadModel(modeloId);
    else {
      if(!this.modelPrice?.catalog)
        this.$emit('empty-model')
    }

    document.addEventListener('click', this.onClickOutside);
  },
  beforeDestroy() {
     document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    ...mapActions("modelo", ["getModelAndPricesFromExtranet"]),
    // Función que se ejecuta al escribir un modelo. Lanza un debounce de medio segundo
    async searchDebounce() {
      this.searchResult = null;
      this.loadingSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.search();
        this.loadingSearch = false;
      }, 500);
    },

    // Funcón que realiza la búsqueda de modelos
    async search() {
      if (!this.searchText) {
        this.searchResult = [];
        return;
      }
      let lang = this.actualLanguageRegion;
      let params = {
        searchQuery: this.searchText,
        Language: lang,
        FilterShop: "STA,ROL,ROLSTA",
        OrderBy: "NOORDER",
        PageSize: "100",
        FilterCollection: "-MARKETING"
      };

      const CancelToken = axios.CancelToken;

      if (this.cancelationToken) {
        this.cancelationToken.cancel("Cancelamos petición previa");
        this.cancelationToken = null;
      }

      this.cancelationToken = CancelToken.source();

      await axios
        .get(`${process.env.VUE_APP_API_SEARCH_ENGINE}/Search/query`, {
          params: params,
          cancelToken: this.cancelationToken.token
        })
        .then(response => {
          if (response.data.Items) {
            let regExp = new RegExp(params.searchQuery, "i");
            this.searchResult = response.data.Items.filter(
              item => this.codigosModelos.find(c => c == item.code) != null
            ).sort((a, b) => {
              return (
                b.objectID?.match(regExp)?.[0]?.length ??
                0 - a.objectID?.match(regExp)?.[0]?.length ??
                0
              );
            });
          }

          this.cancelationToken.token = null;
        })
        .catch(error => {
          console.error(error);
        });
    },

    // FUnción que devuel ve los resultados de la busqueda
    getSearchItemText(model) {
      let result = model.name ;

      if (this.isListMode) {
        result = model.familiename + " " + result + " (" + model.code + ")";
      }
      else {
        result = `<div class="d-flex flex-column justify-center"><span>${model.name}</span><span>${model.code}</span></div>`;
      }
      let textoToFind = this.searchText.toUpperCase();
      // Create array from searchText splitting by space character
      let searchTextArray = textoToFind.split(" ");
      // Loop through each word in searchTextArray
      for (let i = 0; i < searchTextArray.length; i++) {
        result = result.replace(
          searchTextArray[i],
          "<b>" + searchTextArray[i] + "</b>"
        );
      }
      return result;
    },

    getBestProductImage(model) {
      // Valor predeterminado
      const defaultImage = model.imagemodelurl;
      const baseURL = process.env.VUE_APP_STATIC_IMG_URL;
      
      // Obtener información del catálogo
      const catalogItem = this.catalogInfo[model.code];
      
      // Si no hay información del catálogo o colores, retornar la imagen predeterminada
      if (!catalogItem?.colors) return defaultImage;
      
      const colors = catalogItem.colors;
      let targetColor;
      
      // Intentar usar el color "01" primero si existe
      if (colors["01"]) {
        targetColor = colors["01"];
      } else {
        // Si no existe el color "01", usar el primer color disponible
        const colorKeys = Object.keys(colors);
        if (colorKeys.length === 0) return defaultImage;
        
        targetColor = colors[colorKeys[0]];
      }
      
      // Retornar la primera imagen disponible según prioridad con la URL base
      if (targetColor.MINIATURE) {
        return baseURL + targetColor.MINIATURE;
      } else if (targetColor.IMG) {
        return baseURL + targetColor.IMG;
      }
      
      return defaultImage;
    },

    handleWheel(event) {
      
      // Factor básico y umbral para aceleración
      const baseFactor = 1.75;
      const threshold = 40;
      // Ajusta dependiendo de si deltaY indica un scroll rápido o lento
      const accelerationFactor = Math.abs(event.deltaY) > threshold ? 2 : 1;
      
      const speedFactor = baseFactor * accelerationFactor;
      const scrollAmount = -event.deltaY * speedFactor;
      event.currentTarget.scrollLeft += scrollAmount;
    },

    // Función para cargar un modelo en la calculadora
    async loadModel(modelCode) {
      if (!this.hasKeyActive || this.modelCode == modelCode) return;
      this.loadingSearch = true;
      this.getModelAndPricesFromExtranet({
        model: modelCode
      });

      this.searchResult = [];
      this.clickedInside = false;
      this.loadingSearch = false;
      this.searchText = "";
      this.$emit('model-selected')
    },

    // Función para ocultar la lista
    hideList() {
      if (this.loadingSearch || this.clickedInside) return;
      this.showListActive = false;
    },

    // Función para mostrar la lista
    showList() {
      this.showListActive = true;
    },

    onClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.hideList();
      }
    },

    itemMouseDown() {
      this.clickedInside = true;
    },
  }
};
</script>

<style lang="scss">


.searchModelDialog {
  max-width: 505px;
  width: 100%;
  border-radius: 23px !important;
  height: fit-content;
  max-height: 600px;
  position: relative;
  transition: all 0.3s;


  .animated {
    .v-input__slot {
      animation: border-animation-primary 1s linear infinite;
      border-radius: inherit !important;
    }
  }

  .v-input__slot {
    background: #f6f6f6;
    border: 3px solid #f6f6f6;
    div.v-input__prepend-inner i, input {
      color: black !important;
      
    }
  }

  &:hover {
    .v-input__slot {
      background: #ffffff;
    }
  }

  .searchInputModel {} 

  &.listActive {
    border-radius: 23px
  }

  .listSerachModel {
    max-width: 505px;
    min-width: 100%;
    max-height: 450px;
    overflow-y: auto;
    right: 0;
    width: auto;
    position: absolute;
    top: 100%;
    z-index: 16000;
    display: block;
    border: 1px solid var(--v-bannerBackground-base);

    .item-list {
      content-visibility: auto
    }
  }

  .grid-list {
    // max-height: 120px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding: 16px 0;
    white-space: nowrap;
    scrollbar-width: thin;
    /* Prevenir scroll vertical en dispositivos táctiles */
    touch-action: pan-x;

    .model-card {
      flex: 0 0 25%;
      box-sizing: border-box;
      padding: 8px;
      margin-right: 8px;
      min-width: 80px;
      min-height: 100px;
      background: var(--Color-White, #FFF);
      border-radius: 8px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      cursor: pointer;

      .title-model {
        color: var(--Color-Grey-600, #787878) !important;
        text-align: center;
        font-family: $heading-font-family;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      &:hover {
        border: 2px solid var(--v-primary-base);
        padding: 6px;
      }
    }
  }
}

@keyframes border-animation-primary {
  0%,
  100% {
    border-color: white;
  }
  50% {
    border-color: var(--v-colorBtn-base);
  }
}
</style>
